import script from "./PaymentTokensField.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentTokensField.vue?vue&type=script&setup=true&lang=js"

export default script